import { configureStore } from '@reduxjs/toolkit';

import activityStripReducer from './reducers/activityStrip';
import colluderRestrictionsReducer from './reducers/colluderRestrictions';
import currentTableReducer from './reducers/currentTable';
import liveChatNotificationsReducer from './reducers/liveChatNotifications';
import lobbyReducer from './reducers/lobby';
import maintenanceScheduleReducer from './reducers/maintenanceSchedule';
import notificationsReducer from './reducers/notifications';
import playerGamesReducer from './reducers/playerGames';
import playerPromosReducer from './reducers/playerPromos';
import serverDetailsReducer from './reducers/serverDetails';
import sitGoResultReducer from './reducers/sitGoResult';
import tablesReducer from './reducers/tables';
import userReducer from './reducers/user';
import waitlistReducer from './reducers/waitlist';

const reducers = {
  activityStrip: activityStripReducer,
  currentTable: currentTableReducer,
  colluderRestrictions: colluderRestrictionsReducer,
  tables: tablesReducer,
  user: userReducer,
  playerGames: playerGamesReducer,
  playerPromos: playerPromosReducer,
  liveChatNotifications: liveChatNotificationsReducer,
  lobby: lobbyReducer,
  maintenanceSchedule: maintenanceScheduleReducer,
  notifications: notificationsReducer,
  serverDetails: serverDetailsReducer,
  sitGoResult: sitGoResultReducer,
  waitlist: waitlistReducer
};

export const createAppStore = (preloadedState?: any) =>
  configureStore({
    reducer: reducers,
    ...(preloadedState ? { preloadedState } : {}),
    devTools: !!process.env.REACT_APP_REDUX_DEV_TOOL_ENABLE,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false
      })
  });

const store = createAppStore();

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
